import layout from '@/layout'

export default {
  path: '/pre_close_in',
  component: layout,
  redirect: '/pre_close_in/page7',
  name: 'pre_close_in_page7',
  meta: {
    title: 'pre_close_in',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_in/page7',
      name: 'pre_close_in_page7',
      component: () => import('@/views/pre_settle/pre_close/in/index7'),
      meta: {
        title: 'pre_close_in_page7',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
